import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const CGV = () => {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <h1>Conditions Generales de Vente</h1>
        <p>Applicables a compter du 1er janvier 2025</p>
      </div>

      <div className="legal-content">
        <Link to="/" className="legal-back-link">
          ← Retour a l'accueil
        </Link>

        <div className="legal-section">
          <h2>Article 1 - Identification du vendeur</h2>
          <div className="legal-info-box">
            <p><strong>Raison sociale :</strong> STREET DRIVE MARKET</p>
            <p><strong>Nom commercial :</strong> F12IA</p>
            <p><strong>Forme juridique :</strong> SAS au capital de 1 000,00 EUR</p>
            <p><strong>Siege social :</strong> 2 Allee des Pins, 30000 Nimes, France</p>
            <p><strong>SIRET :</strong> 914 635 495 00023</p>
            <p><strong>TVA intracommunautaire :</strong> FR82914635495</p>
            <p><strong>Email :</strong> contact@f12ia.com</p>
          </div>
        </div>

        <div className="legal-section">
          <h2>Article 2 - Objet et champ d'application</h2>
          <p>
            Les presentes Conditions Generales de Vente (CGV) regissent exclusivement les ventes de
            formations en ligne proposees par la societe STREET DRIVE MARKET, sous la marque F12IA,
            sur le site f12ia.com.
          </p>
          <p>
            <strong>Toute commande implique l'acceptation pleine, entiere et sans reserve des presentes CGV.</strong> Le
            client reconnait avoir pris connaissance des CGV avant de passer commande et les avoir acceptees
            en cochant la case prevue a cet effet lors du processus de commande.
          </p>
          <p>
            F12IA se reserve le droit de modifier les presentes CGV a tout moment. Les CGV applicables
            sont celles en vigueur au moment de la commande.
          </p>
        </div>

        <div className="legal-section">
          <h2>Article 3 - Produits et services</h2>
          <p>
            F12IA propose des formations en ligne sur l'intelligence artificielle,
            notamment sur l'utilisation de ChatGPT et Claude Code.
          </p>
          <p>
            Les formations comprennent :
          </p>
          <ul>
            <li>Acces illimite aux modules de formation en ligne</li>
            <li>Acces a vie aux contenus et mises a jour</li>
            <li>Ressources complementaires (prompts, templates, guides)</li>
            <li>Certificat de completion</li>
          </ul>
          <p>
            <strong>Important :</strong> Les formations sont fournies "en l'etat". F12IA se reserve le droit
            de modifier, mettre a jour ou supprimer des contenus a tout moment pour ameliorer la qualite
            pedagogique ou s'adapter aux evolutions technologiques.
          </p>
        </div>

        <div className="legal-section">
          <h2>Article 4 - Prix et modalites de paiement</h2>
          <p>
            Les prix sont indiques en euros TTC (TVA incluse au taux en vigueur). F12IA se reserve le droit
            de modifier ses prix a tout moment. Les formations seront facturees au prix en vigueur
            lors de la validation de la commande.
          </p>
          <div className="legal-info-box">
            <p><strong>Prix actuel de la formation F12IA :</strong> 197 EUR TTC</p>
            <p><strong>Paiement :</strong> Unique, sans abonnement, sans frais caches</p>
            <p><strong>Acces :</strong> Immediat et a vie apres paiement</p>
          </div>
          <p>
            Le paiement s'effectue en ligne par carte bancaire via la plateforme securisee
            Stripe (certification PCI-DSS). <strong>F12IA ne stocke aucune donnee bancaire.</strong>
          </p>
          <p>
            Le paiement est exigible immediatement a la commande. L'acces a la formation
            est accorde des confirmation du paiement par Stripe.
          </p>
        </div>

        <div className="legal-section">
          <h2>Article 5 - Processus de commande</h2>
          <p>
            Pour passer commande, le client doit :
          </p>
          <ul>
            <li>Remplir le formulaire d'inscription avec des informations exactes et verifiables</li>
            <li>Fournir une adresse email valide (necessaire pour l'acces a la formation)</li>
            <li>Accepter les presentes CGV en cochant la case correspondante</li>
            <li>Proceder au paiement securise par carte bancaire</li>
          </ul>
          <p>
            La vente est consideree comme conclue a compter de la confirmation du paiement. Un email
            de confirmation contenant les informations d'acces sera envoye a l'adresse indiquee.
          </p>
          <p>
            <strong>Le client est responsable de l'exactitude des informations fournies.</strong> F12IA
            ne pourra etre tenu responsable en cas d'erreur dans les coordonnees communiquees.
          </p>
        </div>

        <div className="legal-section">
          <h2>Article 6 - Droit de retractation</h2>
          <p>
            Conformement a l'article L221-28 13° du Code de la consommation, <strong>le droit de
            retractation de 14 jours ne peut etre exerce pour les contenus numeriques fournis sur
            un support immateriel dont l'execution a commence avec l'accord prealable et expres du
            consommateur, lequel a renonce a son droit de retractation.</strong>
          </p>
          <p>
            En passant commande et en accedant immediatement a la formation, le client reconnait
            expressement :
          </p>
          <ul>
            <li>Avoir demande l'execution immediate de la formation</li>
            <li>Renoncer a son droit de retractation de 14 jours</li>
          </ul>
          <p>
            Neanmoins, F12IA offre volontairement une garantie commerciale plus avantageuse
            (voir Article 7).
          </p>
        </div>

        <div className="legal-section">
          <h2>Article 7 - Garantie satisfait ou rembourse 30 jours</h2>
          <p>
            F12IA offre une <strong>garantie satisfait ou rembourse de 30 jours</strong> a compter
            de la date d'achat, sous les conditions suivantes :
          </p>
          <div className="legal-info-box">
            <p><strong>Duree :</strong> 30 jours calendaires a compter de la date d'achat</p>
            <p><strong>Demande :</strong> Par email uniquement a contact@f12ia.com</p>
            <p><strong>Delai de remboursement :</strong> Sous 14 jours ouvrables apres validation</p>
            <p><strong>Mode de remboursement :</strong> Meme moyen de paiement que l'achat initial</p>
          </div>
          <p>
            <strong>Conditions et limitations :</strong>
          </p>
          <ul>
            <li>Un seul remboursement par personne physique, par foyer fiscal ou par moyen de paiement</li>
            <li>Le remboursement entraine la suppression immediate et definitive de l'acces a la formation</li>
            <li>Toute tentative de fraude (achats multiples pour remboursements, usurpation d'identite)
                sera poursuivie</li>
            <li>F12IA se reserve le droit de refuser un remboursement en cas d'abus manifeste</li>
          </ul>
          <p>
            <strong>Exclusions :</strong> La garantie ne s'applique pas en cas de violation des presentes CGV,
            notamment en cas de partage de compte ou de piratage du contenu.
          </p>
        </div>

        <div className="legal-section">
          <h2>Article 8 - Acces a la formation et compte utilisateur</h2>
          <p>
            <strong>L'acces a la formation est strictement personnel, individuel et non transmissible.</strong> Les
            identifiants de connexion (email et mot de passe) sont confidentiels et ne doivent en aucun
            cas etre partages, pretes, vendus ou communiques a des tiers.
          </p>
          <p>
            Le client est seul responsable de la confidentialite de ses identifiants et de toute
            utilisation de son compte.
          </p>
          <p>
            <strong>F12IA se reserve le droit de suspendre ou resilier immediatement et sans preavis
            l'acces a la formation, sans remboursement, en cas de :</strong>
          </p>
          <ul>
            <li>Partage des identifiants de connexion avec des tiers</li>
            <li>Connexions simultanees depuis plusieurs appareils ou localisations suspectes</li>
            <li>Tentative de telechargement ou d'enregistrement des contenus</li>
            <li>Reproduction, diffusion ou revente du contenu de la formation</li>
            <li>Utilisation de logiciels de capture d'ecran ou d'enregistrement</li>
            <li>Comportement frauduleux ou contraire aux bonnes moeurs</li>
            <li>Non-respect des presentes CGV</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>Article 9 - Propriete intellectuelle</h2>
          <p>
            <strong>L'ensemble des contenus de la formation</strong> (videos, textes, images, graphiques,
            logos, icones, sons, logiciels, code source, prompts, templates, documents, methodologies)
            <strong>sont proteges par le droit d'auteur, le droit des marques et le droit sui generis
            des bases de donnees.</strong>
          </p>
          <p>
            Ces contenus sont la propriete exclusive de STREET DRIVE MARKET / F12IA ou de ses
            partenaires ayant concede une licence.
          </p>
          <p>
            L'achat de la formation confere uniquement un <strong>droit d'usage personnel, non exclusif
            et non transferable</strong> pour la duree de l'acces.
          </p>
          <p>
            <strong>Sont strictement interdits :</strong>
          </p>
          <ul>
            <li>La reproduction totale ou partielle des contenus</li>
            <li>La modification, adaptation ou traduction des contenus</li>
            <li>La diffusion, publication ou mise a disposition des contenus a des tiers</li>
            <li>La revente, location ou pret des contenus ou de l'acces</li>
            <li>L'utilisation a des fins commerciales ou de formation concurrente</li>
            <li>Le telechargement, l'enregistrement ou la capture des videos</li>
            <li>L'extraction systematique des donnees de la plateforme</li>
          </ul>
          <p>
            <strong>Toute violation de la propriete intellectuelle expose le contrevenant a des
            poursuites civiles et penales</strong> (articles L335-2 et suivants du Code de la propriete
            intellectuelle : jusqu'a 3 ans d'emprisonnement et 300 000 EUR d'amende).
          </p>
        </div>

        <div className="legal-section">
          <h2>Article 10 - Limitation de responsabilite</h2>
          <p>
            F12IA s'engage a fournir une formation de qualite et a mettre en oeuvre tous les moyens
            necessaires pour assurer la disponibilite de la plateforme.
          </p>
          <p>
            <strong>Toutefois, F12IA ne peut garantir :</strong>
          </p>
          <ul>
            <li>Des resultats specifiques suite a la formation (revenus, emploi, competences)</li>
            <li>Une disponibilite ininterrompue de la plateforme (maintenance, bugs, cyberattaques)</li>
            <li>La compatibilite avec tous les appareils et navigateurs</li>
            <li>L'adequation de la formation aux besoins specifiques du client</li>
          </ul>
          <p>
            <strong>F12IA ne pourra en aucun cas etre tenu responsable :</strong>
          </p>
          <ul>
            <li>Des dommages indirects (perte de profits, perte de donnees, prejudice commercial)</li>
            <li>Des decisions prises par le client sur la base de la formation</li>
            <li>De l'utilisation incorrecte ou abusive de la formation</li>
            <li>Des problemes techniques lies a l'equipement ou a la connexion du client</li>
            <li>Des contenus de sites tiers accessibles depuis des liens hypertextes</li>
          </ul>
          <p>
            <strong>En tout etat de cause, la responsabilite de F12IA est limitee au montant
            effectivement paye par le client pour la formation.</strong>
          </p>
        </div>

        <div className="legal-section">
          <h2>Article 11 - Obligations du client</h2>
          <p>
            Le client s'engage a :
          </p>
          <ul>
            <li>Fournir des informations exactes et a jour lors de l'inscription</li>
            <li>Utiliser la formation de maniere loyale et conformement aux presentes CGV</li>
            <li>Ne pas tenter de contourner les mesures de protection techniques</li>
            <li>Respecter la propriete intellectuelle de F12IA</li>
            <li>Ne pas denigrer publiquement F12IA de maniere abusive ou diffamatoire</li>
            <li>Signaler tout dysfonctionnement ou faille de securite detectee</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>Article 12 - Force majeure</h2>
          <p>
            F12IA ne pourra etre tenu responsable de l'inexecution de ses obligations en cas de
            force majeure au sens de l'article 1218 du Code civil, notamment :
          </p>
          <ul>
            <li>Catastrophes naturelles, epidemies, pandemies</li>
            <li>Guerres, emeutes, actes de terrorisme</li>
            <li>Cyberattaques, pannes de serveurs ou d'hebergement</li>
            <li>Decisions gouvernementales ou reglementaires</li>
            <li>Greves ou conflits sociaux chez les prestataires</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>Article 13 - Donnees personnelles</h2>
          <p>
            Les donnees personnelles collectees sont traitees conformement au Reglement General
            sur la Protection des Donnees (RGPD) et a la loi Informatique et Libertes.
          </p>
          <p>
            Pour plus d'informations sur la collecte, le traitement et vos droits, consultez notre{' '}
            <Link to="/politique-confidentialite">Politique de Confidentialite</Link>.
          </p>
        </div>

        <div className="legal-section">
          <h2>Article 14 - Mediation et reglement des litiges</h2>
          <p>
            En cas de litige, le client est invite a contacter en priorite le service client de F12IA
            a l'adresse contact@f12ia.com pour tenter de trouver une solution amiable.
          </p>
          <p>
            Conformement aux articles L611-1 et suivants du Code de la consommation, en cas d'echec
            de la demande de reclamation aupres du service client ou en l'absence de reponse sous
            60 jours, le client peut recourir gratuitement a un mediateur de la consommation :
          </p>
          <div className="legal-info-box">
            <p><strong>Mediateur :</strong> CNPM - MEDIATION DE LA CONSOMMATION</p>
            <p><strong>Site :</strong> cnpm-mediation-consommation.eu</p>
            <p><strong>Adresse :</strong> 27 avenue de la Liberation, 42400 Saint-Chamond</p>
          </div>
          <p>
            Le client peut egalement utiliser la plateforme europeenne de reglement en ligne des
            litiges : <strong>https://ec.europa.eu/consumers/odr</strong>
          </p>
        </div>

        <div className="legal-section">
          <h2>Article 15 - Droit applicable et juridiction competente</h2>
          <p>
            Les presentes CGV sont soumises au droit francais.
          </p>
          <p>
            En cas de litige non resolu par la mediation, les tribunaux du ressort de la Cour
            d'appel de Nimes seront seuls competents, sauf dispositions legales contraires
            applicables au consommateur.
          </p>
        </div>

        <div className="legal-section">
          <h2>Article 16 - Nullite partielle</h2>
          <p>
            Si une ou plusieurs stipulations des presentes CGV etaient declarees nulles ou
            inapplicables par une juridiction competente, les autres stipulations conserveraient
            leur pleine force et portee.
          </p>
        </div>

        <div className="legal-section">
          <h2>Article 17 - Preuve</h2>
          <p>
            Les registres informatiques conserves dans les systemes de F12IA et de ses partenaires
            (notamment Stripe) dans des conditions raisonnables de securite seront consideres comme
            preuves des communications, commandes et paiements intervenus entre les parties.
          </p>
        </div>

        <div className="legal-section">
          <h2>Article 18 - Service client</h2>
          <p>
            Pour toute question, reclamation ou demande d'assistance :
          </p>
          <div className="legal-info-box">
            <p><strong>Email :</strong> contact@f12ia.com</p>
            <p><strong>Delai de reponse :</strong> Sous 48 heures ouvrees</p>
            <p><strong>Horaires :</strong> Du lundi au vendredi, 9h-18h (heure de Paris)</p>
          </div>
        </div>

        <p className="legal-update-date">
          Derniere mise a jour : Janvier 2025
        </p>
      </div>
    </div>
  );
};

export default CGV;
